import { render, staticRenderFns } from "./Polyclinics.vue?vue&type=template&id=c8e78e4e&"
import script from "./Polyclinics.vue?vue&type=script&lang=js&"
export * from "./Polyclinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports